/**
 * Shared validation utilities
 * Consolidates all validation logic used across the application
 */

// ========== Phone Validation ==========
export const PHONE_REGEX = /^[0-9]{10}$/

/**
 * Validates a phone number
 * @param phoneNumber - Phone number to validate
 * @returns true if phone number is valid (10 digits)
 */
export function validatePhoneNumber(phoneNumber: string): boolean {
  const cleaned = phoneNumber.replace(/\D/g, "")
  return PHONE_REGEX.test(cleaned)
}

/**
 * Cleans a phone number by removing non-digit characters
 * @param phoneNumber - Phone number to clean
 * @returns Cleaned phone number with only digits
 */
export function cleanPhoneNumber(phoneNumber: string): string {
  return phoneNumber.replace(/\D/g, "")
}

// ========== Email Validation ==========
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * Validates an email address
 * @param email - Email to validate
 * @returns true if email is valid
 */
export function validateEmail(email: string): boolean {
  return EMAIL_REGEX.test(email)
}

// ========== Name Validation ==========
/**
 * Validates a full name
 * @param name - Name to validate
 * @param minLength - Minimum length (default: 2)
 * @returns true if name is valid
 */
export function validateFullName(name: string, minLength: number = 2): boolean {
  return name.trim().length >= minLength
}
